import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getGainLossColor } from "../../../../../theme";
import { GrowthMetric } from "../../utils/chartDataTransformers";

interface GrowthMetricsDisplayProps {
  metrics: GrowthMetric[];
}

const GrowthMetricsDisplay: React.FC<GrowthMetricsDisplayProps> = ({
  metrics,
}) => {
  const theme = useTheme();

  if (metrics.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
        pt: 1.5,
        pb: 1.5,
        px: 2,
      }}
    >
      <Box sx={{ flex: 1 }} />

      {metrics.map((metric, index) => (
        <Box
          key={metric.label}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.25,
            pr: index < metrics.length - 1 ? 3 : 0,
            borderRight:
              index < metrics.length - 1
                ? "1px solid"
                : "none",
            ...(index < metrics.length - 1 && {
              borderRightColor: "rgba(128, 128, 128, 0.3)",
            }),
          }}
        >
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 500,
              color: "text.secondary",
              textTransform: "none",
              letterSpacing: "0.05em",
            }}
          >
            {metric.label}
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 700,
              color: getGainLossColor(metric.value),
            }}
          >
            {metric.value >= 0 ? "+" : ""}
            {metric.value?.toFixed(1) ?? "0.0"}%
          </Typography>
        </Box>
      ))}

      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <Box
          component="img"
          src={
            theme.palette.mode === "dark"
              ? "/insightLongLogoPrimaryWhiteText.svg"
              : "/insightLongLogoPrimary.svg"
          }
          alt="Insight Analytics"
          sx={{ height: 32 }}
        />
      </Box>
    </Box>
  );
};

export default GrowthMetricsDisplay;
